import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PlusOutlined } from '@ant-design/icons';
import clsx from 'clsx';
import styles from './style.module.less';
const AddItemButton = ({ active, label, onClick }) => (_jsxs("button", { type: "button", tabIndex: 0, className: clsx(styles.addButton, { [styles.active]: active }), onMouseDown: (e) => { e.preventDefault(); e.stopPropagation(); }, onClick: () => {
        onClick === null || onClick === void 0 ? void 0 : onClick();
    }, onKeyDown: (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.stopPropagation();
            onClick === null || onClick === void 0 ? void 0 : onClick();
        }
    }, children: [_jsx(PlusOutlined, { className: styles.addIcon }), _jsx("span", { children: label })] }));
export default AddItemButton;
